<div id="___dashboard" #dash>
    <ng-template pub-comp-list></ng-template>
</div>